(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Pause the carbonation while the hero is offscreen so it costs nothing on scroll.
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ e.target.classList.toggle('is-paused', !e.isIntersecting); });
    }, { rootMargin: '120px' });
    document.querySelectorAll('[data-fizz]').forEach(function(el){ io.observe(el); });
  }

  // Transparent-header-over-hero, reverting once scrolled past. Never touches
  // the header's own position/sticky logic — only measures its height (for
  // the pull-up margin) and toggles a body class the CSS above reacts to.
  var overlayHero = document.querySelector('[data-brand-header-overlay]');
  if(overlayHero){
    var headerEls = document.querySelectorAll('.shopify-section-group-header-group');
    var headerHeight = 0;
    var setHeaderHeight = function(){
      headerHeight = 0;
      headerEls.forEach(function(el){ headerHeight += el.offsetHeight; });
      document.documentElement.style.setProperty('--site-header-h', headerHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    // Transparent while the header still overlaps the hero (hero's bottom
    // edge hasn't yet scrolled above where the header sits); solid once
    // you've scrolled past. rAF-throttled so this costs nothing extra on scroll.
    var ticking = false;
    var updateOverlay = function(){
      var heroBottom = overlayHero.getBoundingClientRect().bottom;
      document.body.classList.toggle('brand-header-overlay-active', heroBottom > headerHeight);
      ticking = false;
    };
    updateOverlay();
    window.addEventListener('scroll', function(){
      if(!ticking){ ticking = true; requestAnimationFrame(updateOverlay); }
    }, { passive: true });
  }

  // Desktop-only pointer parallax on the product row.
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(!window.matchMedia('(pointer: fine)').matches) return;
  document.querySelectorAll('[data-parallax]').forEach(function(root){
    var layer = root.querySelector('[data-parallax-layer]');
    if(!layer) return;
    var raf = null, tx = 0, ty = 0;
    root.addEventListener('pointermove', function(e){
      var r = root.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - .5) * 20;
      ty = ((e.clientY - r.top) / r.height - .5) * 12;
      if(!raf) raf = requestAnimationFrame(function(){
        layer.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0)';
        raf = null;
      });
    });
    root.addEventListener('pointerleave', function(){ layer.style.transform = ''; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-spotlight"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-brand-spot]').forEach(function(root){
  var main = root.querySelector('.brand-spot__main');
  root.querySelectorAll('.brand-spot__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(!main) return;
      main.style.opacity = '0';
      var src = t.getAttribute('data-src');
      window.setTimeout(function(){ main.src = src; main.style.opacity = '1'; }, 150);
      root.querySelectorAll('.brand-spot__thumb').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
  var qty = root.querySelector('.brand-spot__qty');
  if(qty){
    var input = qty.querySelector('input');
    qty.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(input.value,10) || 1;
        v = b.getAttribute('data-qty') === '+' ? v+1 : Math.max(1, v-1);
        input.value = v;
      });
    });
  }
  var selects = root.querySelectorAll('.brand-spot__variant-select');
  var idInput = root.querySelector('[data-brand-spot-id]');
  var dataEl = root.querySelector('[data-brand-variants]');
  var priceNow = root.querySelector('.brand-spot__price-now');
  var addBtn = root.querySelector('.brand-spot__add');
  if(selects.length && idInput && dataEl){
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch(e) {}
    var fmt = function(cents){ try { return (cents/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AED'}); } catch(e){ return ''; } };
    var onChange = function(){
      var chosen = Array.prototype.map.call(selects, function(s){ return s.value; });
      var match = variants.find(function(v){ return (v.options||[]).join(' / ') === chosen.join(' / '); });
      if(match){
        idInput.value = match.id;
        if(priceNow) priceNow.textContent = fmt(match.price);
        if(addBtn){
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-label') || addBtn.textContent : 'Sold out';
        }
      }
    };
    if(addBtn) addBtn.setAttribute('data-label', addBtn.textContent.trim());
    selects.forEach(function(s){ s.addEventListener('change', onChange); });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function closeFooterCols() {
    if (!matchMedia('(max-width: 1024px)').matches) return;
    document.querySelectorAll('.hdt-footer-section .hdt-col-block.open').forEach(function (b) {
      b.classList.remove('open');
      var c = b.querySelector('.hdt-collapse-content');
      if (c) c.style.height = '0px';
    });
  }
  function run() { closeFooterCols(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-compare"]) return;
  try {
    
(function () {
  function initCmpTitles() {
    document.querySelectorAll('.so-compare [data-wl-ttl]').forEach(function (ttl) {
      var head = ttl.querySelector('.so-wl-ttl__head');
      var btn = ttl.querySelector('[data-wl-more]');
      if (!head || !btn) return;
      if (!ttl.classList.contains('is-expanded')) btn.hidden = (head.scrollWidth - head.clientWidth) <= 2;
      if (btn.getAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ttl.classList.add('is-expanded'); });
    });
  }
  function run() { initCmpTitles(); setTimeout(initCmpTitles, 350); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
(function () {
  function initWishlistTools() {
    var tools = document.querySelector('[data-wl-tools]');
    if (!tools) return;
    var grid = document.querySelector('.hdt-collection-products');
    if (!grid) return;
    var input = tools.querySelector('[data-wl-search]');
    var chips = tools.querySelectorAll('[data-wl-filter]');
    var nomatch = document.querySelector('[data-wl-nomatch]');
    var filter = 'all', q = '';
    function title(c) {
      var d = c.getAttribute && c.getAttribute('data-wl-title');
      if (d) return d;
      var t = c.querySelector && c.querySelector('.hdt-card-product__title');
      return t ? t.textContent.trim().toLowerCase() : '';
    }
    function stock(c) {
      var d = c.getAttribute && c.getAttribute('data-wl-stock');
      if (d) return d;
      var soldout = (c.classList && c.classList.contains('hdt-pr-sold_out')) || (c.querySelector && c.querySelector('.hdt-pr-sold_out'));
      return soldout ? 'soon' : 'in';
    }
    function apply() {
      var cards = Array.prototype.slice.call(grid.children);
      var shown = 0;
      cards.forEach(function (c) {
        var okQ = !q || title(c).indexOf(q) > -1;
        var okF = filter === 'all' || stock(c) === filter;
        var vis = okQ && okF;
        c.style.display = vis ? '' : 'none';
        if (vis) shown++;
      });
      if (nomatch) nomatch.hidden = shown > 0 || cards.length === 0;
    }
    function initTitles() {
      document.querySelectorAll('[data-wl-ttl]').forEach(function (ttl) {
        var head = ttl.querySelector('.so-wl-ttl__head');
        var btn = ttl.querySelector('[data-wl-more]');
        if (!head || !btn) return;
        if (!ttl.classList.contains('is-expanded')) {
          btn.hidden = (head.scrollWidth - head.clientWidth) <= 2;
        }
        if (btn.getAttribute('data-bound')) return;
        btn.setAttribute('data-bound', '1');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          ttl.classList.add('is-expanded');
        });
      });
    }
    if (input) input.addEventListener('input', function () { q = this.value.trim().toLowerCase(); apply(); });
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.remove('is-active'); });
        ch.classList.add('is-active');
        filter = ch.getAttribute('data-wl-filter');
        apply();
      });
    });
    initTitles();
    setTimeout(initTitles, 350);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { apply(); initTitles(); });
      mo.observe(grid, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWishlistTools);
  else initWishlistTools();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["so-product-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.so-reviews-section').forEach(function (section) {
  var dialog = section.querySelector('[data-so-dialog]');
  if (!dialog) return;
  var sheet = dialog.querySelector('.so-sheet');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function open() {
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    } else if (!dialog.open) {
      dialog.setAttribute('open', '');
    }
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
  }
  function close() {
    dialog.classList.remove('is-open');
    var finish = function () { if (dialog.open) { try { dialog.close(); } catch (e) {} } };
    if (reduce) { finish(); return; }
    var t = setTimeout(finish, 340);
    if (sheet) sheet.addEventListener('transitionend', function h() { clearTimeout(t); finish(); sheet.removeEventListener('transitionend', h); });
  }

  section.querySelectorAll('[data-so-open]').forEach(function (b) { b.addEventListener('click', open); });
  dialog.querySelectorAll('[data-so-close]').forEach(function (b) { b.addEventListener('click', close); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  var flag = section.querySelector('[data-so-flag]');
  if (flag) {
    open();
    if (flag.getAttribute('data-so-flag') === 'success') {
      try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {}
    }
  }


  /* Live review form (snippets/so-review-form.liquid): photos, validation, multipart POST. */
  var live = section.querySelector('[data-so-review-form]');
  if (live) {
    var files = [];
    var box = live.querySelector('[data-so-photos]');
    var add = live.querySelector('[data-so-photo-add]');
    var picker = live.querySelector('[data-so-file]');
    var err = live.querySelector('[data-so-error]');
    var say = function (msg) { err.textContent = msg || ''; err.hidden = !msg; };
    var draw = function () {
      Array.prototype.forEach.call(box.querySelectorAll('.so-photos__item'), function (n) { n.remove(); });
      files.forEach(function (f, i) {
        var item = document.createElement('span');
        item.className = 'so-photos__item';
        var img = document.createElement('img');
        img.alt = '';
        img.src = URL.createObjectURL(f);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'so-photos__x';
        x.setAttribute('aria-label', live.getAttribute('data-remove') || 'Remove');
        x.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        x.addEventListener('click', function () { files.splice(i, 1); draw(); });
        item.appendChild(img); item.appendChild(x);
        box.insertBefore(item, add);
      });
      add.hidden = files.length >= 3;
    };
    picker.addEventListener('change', function () {
      say('');
      Array.prototype.forEach.call(picker.files, function (f) {
        if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { say(live.getAttribute('data-err-files')); return; }
        if (f.size > 5 * 1024 * 1024) { say(live.getAttribute('data-err-size')); return; }
        if (files.length < 3) files.push(f); else say(live.getAttribute('data-err-files'));
      });
      picker.value = '';
      draw();
    });
    var base = live.getAttribute('action');
    var mode = 'new';
    /* From the review request email: ?rv= is a signed pass from Studio for this buyer and this
       product (30 days, no personal data in it), so they can review without signing in; &stars= is
       the star they tapped. Both leave the address bar at once. Studio swaps the pass for a normal
       review token and the buyer's first name (/apps/so/review/pass). */
    var emailPass = null, emailStars = 0, emailPassReady = null;
    try {
      var qs = new URLSearchParams(location.search), rv = qs.get('rv');
      if (rv) {
        emailStars = parseInt(qs.get('stars'), 10) || 0;
        qs.delete('rv'); qs.delete('stars');
        history.replaceState(null, '', location.pathname + (qs.toString() ? '?' + qs.toString() : '') + location.hash);
        emailPassReady = fetch('/apps/so/review/pass?handle=' + encodeURIComponent(live.querySelector('[name=handle]').value) + '&pass=' + encodeURIComponent(rv), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j && j.ok && j.token) emailPass = { token: j.token, name: String(j.name || '') }; return emailPass; })
          .catch(function () { return null; });
      }
    } catch (e) {}
    var setMode = function (m) {
      mode = m;
      ['[data-so-intro]', '[data-so-submit]', '[data-so-success-title]', '[data-so-success-body]'].forEach(function (s) {
        var el = live.querySelector(s); if (el && el.getAttribute('data-' + m)) el.textContent = el.getAttribute('data-' + m);
      });
      var t = dialog.querySelector('.so-sheet__title'); if (t) t.textContent = live.getAttribute('data-title-' + m);
      live.querySelector('[data-so-photo-field]').hidden = m === 'edit';
      live.querySelector('[data-so-fields]').hidden = false;
      live.querySelector('[data-so-success]').hidden = true;
      say('');
    };
    /* A pass from Studio, through the Shopify app proxy, proving which customer is signed in. */
    var getToken = function () {
      if (emailPass && mode === 'new') return Promise.resolve(emailPass.token);
      return fetch(live.getAttribute('data-token-url'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (!j || !j.ok || !j.token) { var e = new Error(live.getAttribute('data-err-signin')); e.login = true; throw e; } return j.token; });
    };
    section.querySelectorAll('[data-so-open]').forEach(function (b) { b.addEventListener('click', function () { setMode('new'); live.reset(); live.querySelector('[name=id]').value = ''; files = []; draw(); }); });
    live.addEventListener('submit', function (e) {
      e.preventDefault();
      say('');
      var fd = new FormData(live);
      fd.delete('files');
      var body = String(fd.get('body') || '').trim();
      if (!fd.get('rating') || body.length < 10) { say(live.getAttribute('data-err-required')); return; }
      if (!fd.get('recommend')) fd.set('recommend', '0');
      if (mode === 'new') files.forEach(function (f) { fd.append('files', f, f.name); });
      var btn = live.querySelector('[data-so-submit]');
      var label = btn.textContent;
      btn.classList.add('is-loading'); btn.textContent = btn.getAttribute('data-loading') || label;
      getToken()
        .then(function (tok) {
          fd.set('token', tok);
          return fetch(mode === 'edit' ? base + '/edit' : base, { method: 'POST', body: fd });
        })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) { var e = new Error(j.error || ''); e.login = j.login; throw e; } return j; }); })
        .then(function () {
          live.querySelector('[data-so-fields]').hidden = true;
          live.querySelector('[data-so-success]').hidden = false;
          if (mode === 'edit') { var li = section.querySelector('[data-so-edit="' + fd.get('id') + '"]'); if (li) { li = li.closest('.so-review'); if (li) li.classList.add('is-pending'); } }
        })
        .catch(function (x) {
          if (x && x.login) { location.href = live.getAttribute('data-login'); return; }
          say((x && x.message) || live.getAttribute('data-err-generic'));
        })
        .then(function () { btn.classList.remove('is-loading'); btn.textContent = label; });
    });
    section.querySelectorAll('[data-so-edit]').forEach(function (b) {
      b.addEventListener('click', function () {
        setMode('edit');
        live.reset();
        live.querySelector('[name=id]').value = b.getAttribute('data-so-edit');
        var star = live.querySelector('[name=rating][value="' + b.getAttribute('data-r') + '"]'); if (star) star.checked = true;
        live.querySelector('[name=title]').value = b.getAttribute('data-t') || '';
        live.querySelector('[name=body]').value = b.getAttribute('data-b') || '';
        live.querySelector('[name=recommend]').checked = b.getAttribute('data-rec') === '1';
        open();
      });
    });
    section.querySelectorAll('[data-so-delete]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!window.confirm(b.getAttribute('data-confirm'))) return;
        b.disabled = true;
        getToken()
          .then(function (tok) { return fetch(base + '/delete', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: tok, id: b.getAttribute('data-so-delete') }) }); })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || ''); }); })
          .then(function () {
            var li = b.closest('.so-review');
            if (li) { li.innerHTML = '<p class="so-review__gone"></p>'; li.querySelector('p').textContent = b.getAttribute('data-done'); }
          })
          .catch(function (x) { b.disabled = false; if (x && x.message) window.alert(x.message); });
      });
    });
  }

  /* Opened from the review request email: show the form (not the sign-in panel), with the star they tapped. */
  if (live && emailPassReady) emailPassReady.then(function (pass) {
    if (!pass) { open(); return; }
    if (live.hasAttribute('data-so-guest')) {
      live.hidden = false;
      var signin = dialog.querySelector('[data-so-signin]'); if (signin) signin.hidden = true;
      var asme = live.querySelector('[data-so-asme]');
      if (asme && emailPass.name) {
        asme.querySelector('.so-asme__avatar').textContent = emailPass.name.charAt(0).toUpperCase();
        asme.lastElementChild.textContent = asme.getAttribute('data-tpl').replace('%%', emailPass.name);
      } else if (asme) asme.hidden = true;
    }
    setMode('new'); live.reset(); live.querySelector('[name=id]').value = ''; files = []; draw();
    var star = live.querySelector('[name=rating][value="' + emailStars + '"]'); if (star) star.checked = true;
    open();
  });

  /* Helpful votes: counts from the worker, one vote per device remembered locally. */
  var list = section.querySelector('[data-so-help-endpoint]');
  var helpBtns = section.querySelectorAll('[data-so-help]');
  if (list && helpBtns.length) {
    var ep = list.getAttribute('data-so-help-endpoint');
    var voted = {};
    try { voted = JSON.parse(localStorage.getItem('so-rv-helpful') || '{}'); } catch (e) {}
    var ids = Array.prototype.map.call(helpBtns, function (b) { return b.getAttribute('data-so-help'); });
    var paint = function (b, n) {
      var out = b.querySelector('[data-n]');
      out.textContent = n > 0 ? ' (' + n + ')' : '';
      if (voted[b.getAttribute('data-so-help')]) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); }
    };
    fetch(ep + '?ids=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (j) { Array.prototype.forEach.call(helpBtns, function (b) { paint(b, (j.counts || {})[b.getAttribute('data-so-help')] || 0); }); })
      .catch(function () { Array.prototype.forEach.call(helpBtns, function (b) { paint(b, 0); }); });
    Array.prototype.forEach.call(helpBtns, function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-so-help');
        if (voted[id]) return;
        voted[id] = 1;
        try { localStorage.setItem('so-rv-helpful', JSON.stringify(voted)); } catch (e) {}
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        fetch(ep, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id }) })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (typeof j.count === 'number') paint(b, j.count); })
          .catch(function () {});
      });
    });
  }

  var form = section.querySelector('.so-form:not([data-so-review-form])');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-so-submit]');
      if (btn) { btn.classList.add('is-loading'); var l = btn.getAttribute('data-loading'); if (l) btn.textContent = l; }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toolbar-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The sticky add-to-cart bar was offset by a hard-coded 6.7rem, which
    // assumed a 67px bar. With labels on it is 72px plus its 8px inset, so the
    // bar overlapped the nav; and that offset only applied up to 1024px while
    // the nav itself stays visible to 1149px, leaving no offset at all on a
    // landscape tablet. Publishing the real occupied height lets anything
    // anchored to the bottom sit clear of it at every size.
    function publish() {
      var bar = document.querySelector('.hdt-toolbar.hdt-fixed');
      var occupied = 0;
      if (bar) {
        var rect = bar.getBoundingClientRect();
        if (rect.height > 0 && getComputedStyle(bar).display !== 'none') {
          occupied = Math.max(0, Math.round(window.innerHeight - rect.top));
        }
      }
      document.documentElement.style.setProperty('--so-bottomnav-h', occupied + 'px');
    }

    function watch() {
      publish();
      var bar = document.querySelector('.hdt-toolbar.hdt-fixed');
      if (bar && window.ResizeObserver) new ResizeObserver(publish).observe(bar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
    window.addEventListener('resize', publish, { passive: true });
    window.addEventListener('orientationchange', publish, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(publish);
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();
})();
